module.exports = __webpack_public_path__ + "img/msg.64fc5739.png";